// extracted by mini-css-extract-plugin
export default {"productsButton":"CustomerProductsCard_productsButton__+nOrU","productTypesContainer":"CustomerProductsCard_productTypesContainer__va790"};